<template>
  <!-- 取回/出售订单-溢价处理 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="溢价处理"
      width="300px"
      @close="closeDialog"
      center
    >
      <el-form :inline="true" :model="premium" class="demo-form-inline">
        <el-form-item label="开始时间：">
          <el-time-picker
            v-model="premium.start_time"
            placeholder="开始时间"
            value-format="HH:mm"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间：">
          <el-time-picker
            v-model="premium.end_time"
            placeholder="结束时间"
            value-format="HH:mm"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="溢价处理">
          <el-switch
            style="
              display: block;
              height: 33px;
              display: flex;
              align-items: center;
            "
            v-model="premium.val"
            active-text="开启"
            inactive-text="关闭"
            @change="premiumChange"
          ></el-switch>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions,mapMutations  } from 'vuex'
import http, { getData,postData,patchData, server, postApiData, patchApiData, getApiData } from '../../http'

export default {
  components: {
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      premium: {//溢价处理的数据
        val: false,
        start_time: '10:10:10',
        end_time: '11:11:11'
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    }
  },
  watch: {
    dialogVisible(val){
      if(val){
        this.getPremiumChange()//获取溢价开关状态
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getPremiumChange() {
      //获取溢价处理开关数据
       getData('extract_premium_open').then(res => {
         if(res){
           this.premium.val=res.data.val?true:false
           this.premium.start_time=res.data.remarks.start_time
           this.premium.end_time=res.data.remarks.end_time
         }
       })
    },
    premiumChange(val) {
      //溢价处理开关
      let params = this.premium
      postData('extract_premium_open', this.premium).then(res => {
        this.$message.success('操作成功')
      }).catch(() => {
        this.premium.val ? this.premium.val = false : this.premium.val = true
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }

  }

}
</script>
<style lang="less" scoped>
</style>